import { Component, Input, OnInit } from '@angular/core';
import {
  checkSegmentIsAffected,
  getFlightsNewInfoEstimatedDeparture,
  parseTime,
} from '@app/utils/functions/srIrops';
/**
 * Componente que muestra la información del nuevo vuelo afectado por IROPs (Irregular Operations).
 * 
 * Este componente maneja la información sobre los segmentos afectados y los horarios del vuelo actualizado.
 */
@Component({
    selector: 'new-flight-info-irops-view',
    templateUrl: './new-flight-info-irops-view.component.html',
    styleUrls: ['./new-flight-info-irops-view.component.scss'],
    standalone: false
})
export class NewFlightInfoIropsViewComponent implements OnInit {
 /** Segmento modificado del vuelo */
 @Input() segModify: any;
  
 /** Primer segmento del vuelo */
 @Input() firstSegment: any;
 
 /** Último segmento del vuelo */
 @Input() lastSegment: any;
 
 /** Primer segmento afectado */
 @Input() firstAfected: any;
 
 /** Último segmento afectado */
 @Input() lastAfected: any;
 
 /** Horarios programados del vuelo */
 @Input() schedules: any;

  constructor() { }

  ngOnInit() {
  }
/**
   * Obtiene el número de vuelo en formato "Operador Código"
   */
  get flightNumber() {
    const operatingCarrier = this.firstAfected?.operatingCarrier;
    const operatingCode = parseInt(this.firstAfected?.operatingFlightCode);

    return `${operatingCarrier} ${operatingCode}`;
  }
 /**
   * Obtiene el horario del vuelo afectado, considerando posibles cambios en los segmentos
   */
  get affectedDepartureDateTime(): string {
    return getFlightsNewInfoEstimatedDeparture(this.firstAfected);
  }

  get timeAfected() { 
    return parseTime(
      checkSegmentIsAffected(this.firstSegment)
        ? getFlightsNewInfoEstimatedDeparture(this.firstSegment)
        : getFlightsNewInfoEstimatedDeparture(this.firstAfected),
      checkSegmentIsAffected(this.lastSegment) ? this.lastSegment?.flightsNewInfo?.arrivalDateTime : this.lastAfected?.flightsNewInfo?.arrivalDateTime
    );
  }

}
